/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AdminResourceAccessGroupsList,
  AdminUser,
  AdminUserInput,
  AdminUsers,
  AdminUsersParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create Admin User
 */
export const createAdminUser = (
    adminUserInput: MaybeRefOrGetter<AdminUserInput>,
 signal?: AbortSignal
) => {
      adminUserInput = toValue(adminUserInput);

      return axiosClient<AdminUser>(
      {url: `/admin_users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminUserInput, signal
    },
      );
    }




export const getCreateAdminUserMutationKey = () => ['createAdminUser'] as const;

export const getCreateAdminUserMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminUser>>, TError,CreateAdminUserMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAdminUser>>, TError,CreateAdminUserMutationVariables, TContext> => {

const mutationKey = getCreateAdminUserMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminUser>>, CreateAdminUserMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createAdminUser(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminUserMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminUser>>>
    export type CreateAdminUserMutationBody = AdminUserInput
    export type CreateAdminUserMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CreateAdminUserMutationVariables = {data: AdminUserInput}

    /**
 * @summary Create Admin User
 */
export const useCreateAdminUser = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminUser>>, TError,CreateAdminUserMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAdminUser>>,
        TError,
        CreateAdminUserMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAdminUserMutationOptions(options), queryClient);
    }
    /**
 * @summary Admin Users list
 */
export const adminUsers = (
    params?: MaybeRefOrGetter<AdminUsersParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<AdminUsers>(
      {url: `/admin_users`, method: 'GET',
        params, signal
    },
      );
    }




export const getAdminUsersQueryKey = (params?: MaybeRefOrGetter<AdminUsersParams>,) => {
    return [
    'admin_users', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminUsersQueryOptions = <TData = Awaited<ReturnType<typeof adminUsers>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<AdminUsersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUsers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getAdminUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminUsers>>> = ({ signal }) => adminUsers(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminUsers>>, TError, TData>
}

export type AdminUsersQueryResult = NonNullable<Awaited<ReturnType<typeof adminUsers>>>
export type AdminUsersQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Admin Users list
 */

export function useAdminUsers<TData = Awaited<ReturnType<typeof adminUsers>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<AdminUsersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary My Data
 */
export const me = (

 signal?: AbortSignal
) => {


      return axiosClient<AdminUser>(
      {url: `/admin_users/me`, method: 'GET', signal
    },
      );
    }




export const getMeQueryKey = () => {
    return [
    'admin_users','me'
    ] as const;
    }


export const getMeQueryOptions = <TData = Awaited<ReturnType<typeof me>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof me>>> = ({ signal }) => me(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>
}

export type MeQueryResult = NonNullable<Awaited<ReturnType<typeof me>>>
export type MeQueryError = ErrorType<StandardError>


/**
 * @summary My Data
 */

export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy Admin User
 */
export const destroyAdminUser = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AdminUser>(
      {url: `/admin_users/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyAdminUserMutationKey = () => ['destroyAdminUser'] as const;

export const getDestroyAdminUserMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAdminUser>>, TError,DestroyAdminUserMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyAdminUser>>, TError,DestroyAdminUserMutationVariables, TContext> => {

const mutationKey = getDestroyAdminUserMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyAdminUser>>, DestroyAdminUserMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyAdminUser(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyAdminUserMutationResult = NonNullable<Awaited<ReturnType<typeof destroyAdminUser>>>

    export type DestroyAdminUserMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyAdminUserMutationVariables = {id: string}

    /**
 * @summary Destroy Admin User
 */
export const useDestroyAdminUser = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAdminUser>>, TError,DestroyAdminUserMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyAdminUser>>,
        TError,
        DestroyAdminUserMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyAdminUserMutationOptions(options), queryClient);
    }
    /**
 * @summary Admin User Detail
 */
export const adminUser = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AdminUser>(
      {url: `/admin_users/${id}`, method: 'GET', signal
    },
      );
    }




export const getAdminUserQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'admin_users',id
    ] as const;
    }


export const getAdminUserQueryOptions = <TData = Awaited<ReturnType<typeof adminUser>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getAdminUserQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminUser>>> = ({ signal }) => adminUser(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminUser>>, TError, TData>
}

export type AdminUserQueryResult = NonNullable<Awaited<ReturnType<typeof adminUser>>>
export type AdminUserQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Admin User Detail
 */

export function useAdminUser<TData = Awaited<ReturnType<typeof adminUser>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminUser>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminUserQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Admin User
 */
export const updateAdminUser = (
    id: MaybeRefOrGetter<string>,
    adminUserInput: MaybeRefOrGetter<AdminUserInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
adminUserInput = toValue(adminUserInput);

      return axiosClient<AdminUser>(
      {url: `/admin_users/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminUserInput, signal
    },
      );
    }




export const getUpdateAdminUserMutationKey = () => ['updateAdminUser'] as const;

export const getUpdateAdminUserMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminUser>>, TError,UpdateAdminUserMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminUser>>, TError,UpdateAdminUserMutationVariables, TContext> => {

const mutationKey = getUpdateAdminUserMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminUser>>, UpdateAdminUserMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateAdminUser(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminUser>>>
    export type UpdateAdminUserMutationBody = AdminUserInput
    export type UpdateAdminUserMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateAdminUserMutationVariables = {id: string;data: AdminUserInput}

    /**
 * @summary Update Admin User
 */
export const useUpdateAdminUser = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminUser>>, TError,UpdateAdminUserMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAdminUser>>,
        TError,
        UpdateAdminUserMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAdminUserMutationOptions(options), queryClient);
    }
    /**
 * @summary Resource Access Catalog
 */
export const resourceAccessCatalog = (

 signal?: AbortSignal
) => {


      return axiosClient<AdminResourceAccessGroupsList>(
      {url: `/resource-access-catalog`, method: 'GET', signal
    },
      );
    }




export const getResourceAccessCatalogQueryKey = () => {
    return [
    'resource-access-catalog'
    ] as const;
    }


export const getResourceAccessCatalogQueryOptions = <TData = Awaited<ReturnType<typeof resourceAccessCatalog>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resourceAccessCatalog>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getResourceAccessCatalogQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof resourceAccessCatalog>>> = ({ signal }) => resourceAccessCatalog(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof resourceAccessCatalog>>, TError, TData>
}

export type ResourceAccessCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof resourceAccessCatalog>>>
export type ResourceAccessCatalogQueryError = ErrorType<StandardError>


/**
 * @summary Resource Access Catalog
 */

export function useResourceAccessCatalog<TData = Awaited<ReturnType<typeof resourceAccessCatalog>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resourceAccessCatalog>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getResourceAccessCatalogQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






